import { useEffect, useRef } from 'react';
import './HeroBackgroundVideo.css';

/**
 * Full-bleed looping hero background (MP4 URL from Firebase Storage or any https URL).
 * Parent should be position: relative; overflow: hidden;
 */
function HeroBackgroundVideo({ videoUrl }) {
  const videoRef = useRef(null);
  const url = typeof videoUrl === 'string' ? videoUrl.trim() : '';

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !url) return undefined;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const tryPlay = () => {
      const promise = video.play();
      if (promise?.catch) {
        promise.catch(() => {});
      }
    };

    const onCanPlay = () => {
      tryPlay();
      video.removeEventListener('canplay', onCanPlay);
    };

    video.addEventListener('canplay', onCanPlay);
    tryPlay();

    return () => {
      video.removeEventListener('canplay', onCanPlay);
    };
  }, [url]);

  if (!url) return null;

  return (
    <>
      <div className="hero-bg-video-layer" aria-hidden="true">
        <video
          ref={videoRef}
          className="hero-bg-video"
          src={url}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          controls={false}
          controlsList="nodownload noplaybackrate noremoteplayback"
          disablePictureInPicture
          disableRemotePlayback
          tabIndex={-1}
          aria-hidden="true"
        />
      </div>
      <div className="hero-bg-video-scrim" aria-hidden="true" />
    </>
  );
}

export default HeroBackgroundVideo;
